module.exports = {
          srcSet: __webpack_public_path__ + "images/1912-421979099cb36afbc2632df514902c91-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1912-9659f24834bd88f26435f6cbc35709db-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1912-421979099cb36afbc2632df514902c91-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1912-9659f24834bd88f26435f6cbc35709db-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1912-421979099cb36afbc2632df514902c91-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1912-421979099cb36afbc2632df514902c91-320.jpg"},
          
          width: 320,
          height: 251
        }